import React from "react";
import { Navigate, Outlet } from "react-router-dom";

const QCRouteMiddleware = ({ fallbackPath }) => {
  const permissions = JSON.parse(sessionStorage.getItem("permissions"));

  if (
    permissions.qc_order_create === true ||
    permissions.qc_order_edit === true ||
    permissions.qc_order_view === true
  ) {
    return <Outlet />;
  } else {
    return <Navigate to={fallbackPath} />;
  }
};

export default QCRouteMiddleware;
